import { Component, OnInit } from '@angular/core';

import { LocalStorageService } from 'angular-2-local-storage';

import { Sucursal } from '../../model/sucursal';
import { Consorcio } from '../../model/consorcio';
import { ReporteInventario } from '../../model/reporte-inventario';
import { ReporteInventarioSeries } from '../../model/reporte-inventario-series';

import { ConsorciosService } from '../../services/consorcios.service';
import { SucursalService } from '../../services/sucursal.service';
import { ReporteInventarioService } from '../../services/reporte-inventario.service';

@Component({
  selector: 'app-reporte-inventario-series',
  templateUrl: './reporte-inventario-series.component.html',
  styleUrls: ['./reporte-inventario-series.component.css']
})
export class ReporteInventarioSeriesComponent implements OnInit {


  public fechaActual: Date;
  public filtro: boolean;

  public codigoSucursal: string;
  public consorcio: Consorcio;
  public consorcios: Consorcio[];
  public inventarios: ReporteInventario[];
public _filtro:string;
  public sucursal: Sucursal;
  public sucursales: Sucursal[];
  public codigoArticulo: string;
  public nombreArticulo: string;
  public usuario: string;

  public buscando: boolean;


  public series: ReporteInventarioSeries[];


  public criterio: any;

  public query: any;


  constructor(
    private _consorcioService: ConsorciosService,
    private _sucursalService: SucursalService,
    private _inventario: ReporteInventarioService
  ) { }

  ngOnInit() {
this._filtro = "";
    this.series = [];
    this.buscando = false;

    this.usuario = sessionStorage.getItem("login");

    this.codigoArticulo = "";
    this.nombreArticulo = "";

    this.fechaActual = new Date();
    this.filtro = true;

    this.cargarConsorcios();

  }

  cargarConsorcios() {

    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
        this.buscando = false;;
      });
  }

  cargarSucursales() {
    if (this.consorcio === null) {
      return;
    }
    this.query = { "email": sessionStorage.getItem("login"), "codigoConsorcio": this.consorcio.codigoConsorcio }

    this._sucursalService.getSucursalesUsuario(this.query)
      .subscribe(
      data => this.sucursales = data,
      err => {
        console.clear();
        console.log(err._body);
      });

  }

  filtroToggle() {
    this.filtro = !this.filtro;
  }


  realizarConsulta() {

    if (this.consorcio === undefined) {
      return;
    }

    if (this.codigoSucursal === "") {
      return;
    }

    this.buscando = true;

    this.query = { "ETIQUETA": "SERIES", "QUERY": "codigoConsorcio:" + this.consorcio.codigoConsorcio + "|" + "codigoSucursal:" + this.codigoSucursal + "|" + "codigoArticulo:" + this.codigoArticulo + "|" + "nombreArticulo:" + this.nombreArticulo };


    this._inventario.getInventarioSeries(this.query)
      .subscribe(
      data => {
        this.series = data;
        this.buscando = false;
        console.clear();
        console.log("==========================REPORTE DE SERIES==========================");
        console.log(this.series);


      },
      err => {
        this.buscando = false;
        console.log(err._body);
      });

    this.filtro = false;
  }




  exportar() {

    var ar = this.series;

    //comprobamos compatibilidad
    if (window.Blob && (window.URL)) {
      var contenido = "", d = new Date(), blob, _reader, save, clicEvent;
      //creamos contenido del archivo
      for (var i = 0; i < ar.length; i++) {
        //construimos cabecera del csv
        if (i == 0)
          contenido += Object.keys(ar[i]).join(";") + "\n";
        //resto del contenido
        contenido += Object.keys(ar[i]).map(function (key) {
          return ar[i][key];
        }).join(";") + "\n";
      }
      //creamos el blob
      blob = new Blob(["\ufeff", contenido], { type: 'text/csv' });
      //creamos el reader
      _reader = new FileReader();
      _reader.onload = function (event) {
        //escuchamos su evento load y creamos un enlace en dom
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        //aquí le damos nombre al archivo
        save.download = "ReporteInventarioSeries" + d.getDate() + "_" + (d.getMonth() + 1) + "_" + d.getFullYear() + ".csv";
        try {
          //creamos un evento click
          clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        } catch (e) {
          //si llega aquí es que probablemente implemente la forma antigua de crear un enlace
          clicEvent = document.createEvent("MouseEvent");
          clicEvent.initEvent('click', true, true);
        }
        //disparamos el evento
        save.dispatchEvent(clicEvent);
        //liberamos el objeto window.URL
        (window.URL).revokeObjectURL(save.href);
      }
      //leemos como url
      _reader.readAsDataURL(blob);
    } else {
      //el navegador no admite esta opción
      alert("Su navegador no permite esta acción");
    }
  }

  imprimir(){
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
}


}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/reporte-inventario-series/reporte-inventario-series.component.ts